import { stringify } from 'qs'
import assert from './assert'

const basePath = ({ workspaceSlug, spaceSlug }) => {
  let path = `/${workspaceSlug}/personas`

  if (spaceSlug) {
    path += `/spaces/${spaceSlug}`
  }

  return path
}

/**
 * Used within the global nav to highlight the Personas nav item.
 */
export const personasPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas`
}

export const personasCreatePath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas/new`
}

export const personasExplorerPath = args => {
  assert(args, 'workspaceSlug')
  const path = `${basePath(args)}/explorer`

  if (args.query) {
    assert(args.query, 'accounts')

    if (args.query.accounts) {
      const query = stringify({
        accounts: args.query.accounts
      })

      return `${path}?${query}`
    }
  }

  return path
}

export const personasExplorerRecordPath = args => {
  assert(args, ['workspaceSlug', 'recordId'])
  const path = `${basePath(args)}/explorer/${args.recordId}`

  if (args.query) {
    assert(args.query, 'accounts')

    if (args.query.accounts) {
      const query = stringify({
        accounts: args.query.accounts
      })

      return `${path}?${query}`
    }
  }

  return path
}

export const personasDestinationsPath = args => {
  assert(args, 'workspaceSlug')
  return `${basePath(args)}/destinations`
}

export const personasDestinationSettingsPath = args => {
  assert(args, 'workspaceSlug')
  return `${basePath(args)}/destinations/${args.destinationId}`
}

export const personasTraitsPath = args => {
  assert(args, 'workspaceSlug')
  return `${basePath(args)}/traits`
}

export const personasTraitsCreatePath = args => {
  assert(args, 'workspaceSlug')
  return `${basePath(args)}/traits/new`
}

export const personasTraitPath = args => {
  assert(args, ['workspaceSlug', 'traitId'])
  return `${basePath(args)}/traits/${args.traitId}/overview`
}

export const personasTraitBuilderPath = args => {
  assert(args, ['workspaceSlug', 'traitId'])
  return `${basePath(args)}/traits/${args.traitId}/edit`
}

export const personasTraitSettingsPath = args => {
  assert(args, ['workspaceSlug', 'traitId'])
  return `${basePath(args)}/traits/${args.traitId}/settings`
}

export const personasAudiencesPath = args => {
  assert(args, 'workspaceSlug')
  return `${basePath(args)}/audiences`
}

export const personasAudiencesCreatePath = args => {
  assert(args, 'workspaceSlug')
  const path = `${basePath(args)}/audiences/new`

  if (args.query) {
    assert(args.query, 'templates')

    const query = stringify({
      templates: args.query.templates
    })

    return `${path}?${query}`
  }

  return path
}

export const personasAudienceOverviewPath = args => {
  assert(args, 'workspaceSlug')
  assert(args, 'audienceId')
  return `${basePath(args)}/audiences/${args.audienceId}/overview`
}

export const personasAudienceBuilderPath = args => {
  assert(args, ['workspaceSlug', 'audienceId'])
  return `${basePath(args)}/audiences/${args.audienceId}/edit`
}

export const personasAudienceSettingsPath = args => {
  assert(args, ['workspaceSlug', 'audienceId'])
  return `${basePath(args)}/audiences/${args.audienceId}/settings`
}

export const personasSettingsPath = args => {
  assert(args, 'workspaceSlug')
  return `${basePath(args)}/settings`
}

export const personasSettingsSourcesPath = args => {
  assert(args, 'workspaceSlug')
  return `${basePath(args)}/settings/sources`
}

export const personasWarehouseSourcesPath = args => {
  assert(args, 'workspaceSlug')
  return `${basePath(args)}/settings/warehouse-sources`
}

export const personasWarehouseSourcePath = args => {
  assert(args, ['workspaceSlug', 'warehouseSourceId'])
  return `${basePath(args)}/settings/warehouse-sources/${
    args.warehouseSourceId
  }`
}

export const personasWarehouseSourcesCreatePath = args => {
  assert(args, 'workspaceSlug')
  return `${basePath(args)}/settings/warehouse-sources/new`
}

export const personasSettingsAPIAccessPath = args => {
  assert(args, 'workspaceSlug')
  return `${basePath(args)}/settings/api-access`
}

export const personasSettingsConnectionPolicyPath = args => {
  assert(args, 'workspaceSlug')
  return `${basePath(args)}/settings/connection-policy`
}

export const personasSettingsLabelsPath = args => {
  assert(args, 'workspaceSlug')
  return `${basePath(args)}/settings/labels`
}

export const personasSettingsIdentityResolutionPath = args => {
  assert(args, 'workspaceSlug')
  return `${basePath(args)}/settings/identity-resolution`
}

export const personasSettingsFeaturesPath = args => {
  assert(args, 'workspaceSlug')
  return `${basePath(args)}/settings/features`
}

export const personasSpacesSettingsPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/settings/spaces`
}

export const personasSpacesCreatePath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/settings/spaces/new`
}
